import { render, staticRenderFns } from "./goodListScroll.vue?vue&type=template&id=6584540f&scoped=true"
import script from "./goodListScroll.vue?vue&type=script&lang=js"
export * from "./goodListScroll.vue?vue&type=script&lang=js"
import style0 from "./goodListScroll.vue?vue&type=style&index=0&id=6584540f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584540f",
  null
  
)

export default component.exports